import { render } from "./IconUnderlineBlue.vue?vue&type=template&id=609b5c9a"
const script = {}

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__